import * as React from 'react';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

export function LabeledCheckbox({ name, label, checked, value, onChange, ...props }) {
    return (
        <FormGroup {...props}>
            <FormControlLabel control={<Checkbox name={name} checked={checked} value={value}/>} label={label} onChange={onChange}/>
        </FormGroup>
    );
}
